import {NOT_AVAILABLE} from "@/store/leads/mutation-types";

const ACCOUNT_ERROR_MISSING_EMAIL = '104';

export default {
  computed: {
    available: function () {
      return !this.hasError || this.isAccountError;
    },
    notAvailableReason: {
      get: function() {
        return this.hasError
          ? {message: this.$errorMessages.getErrorMessage('lead_availability', this.errorString, this.isAccountError), email: this.isAccountError}
          : null;
      },
      set: function(value) {
        this.$store.commit(NOT_AVAILABLE, value);
      }
    },
    isAccountError: function() {
      const code = this.$errorMessages.getErrorCode(this.errorString);
      return code === ACCOUNT_ERROR_MISSING_EMAIL;
    },
    errorString: function() {
      return Object.values(this.$store.state.leads.NOT_AVAILABLE)[0];
    },
    hasError: {
      get: function() {
        return this.$store.state.leads.NOT_AVAILABLE !== null;
      },
      set: function() {
        this.$store.commit(NOT_AVAILABLE, null);
      }
    }
  }
}
